import { Injectable } from '@angular/core';
import { Platform, ToastController } from 'ionic-angular';

/*
  Generated class for the PwaProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PwaProvider {

  public isCordova: boolean = false;
  private toast = null;
  
  constructor(private platform: Platform, private toastCtrl: ToastController) {
    // console.log(this.isIOS());
    this.isCordova = platform.is('cordova');

  }


  public alertPWA(){
    
    if (!this.appIsOnDevice() && !this.platform.is('cordova')) {
      // the app is in PWA mode, we proceed to detect device and browser support:
      let userAgent = navigator.userAgent;
      if (userAgent.match(/Android/i)) {
        //code for "add to desktop" for Android:
        this.presentToast("Tap ' ... ' in the top panel of your browser and then 'Add to Home Screen' to get full screen mode and faster loading times.", "bottom", '')
      }
      else if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i)) {
        //code for "add to desktop" for iOS:
        this.presentToast("Tap 'Share' in the bottom panel of your browser and then 'Add to Home Screen' to get full screen mode and faster loading times.", "bottom", 'speech-bubble-ios')
      }
    }
  }

  private appIsOnDevice(){
    return matchMedia('(display-mode: standalone)').matches;

  }

  private presentToast(message, position, cssclass) {
    // prevent toasts from "stacking":
    if (this.toast) {
        this.toast.dismiss();
        this.toast = null;
    }
    // create a toast:

    this.toast = this.toastCtrl.create({
        message: message,
        closeButtonText: "OK",
        showCloseButton: true,
        cssClass: cssclass,
        position: position,
    });
    this.toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/pwa/pwa.ts